// extracted by mini-css-extract-plugin
export default {"footer":"footer-styles_footer__Gv6gk"};